import { useAppSelector } from '../hooks';
import { store } from '../store';
import {
  ViewStates,
  dispatchClearView,
  dispatchViewStates,
  viewStateSelectors,
} from './view.slice';

export class ViewStateService<ViewState extends { [key: string]: string }> {
  protected dispatchViewStates = dispatchViewStates;
  protected viewStateSelectors = viewStateSelectors;

  constructor(protected viewName: ViewStates) {}

  viewStateSelector = (): ViewState => {
    return this.viewStateSelectors(store.getState())[this.viewName];
  };

  useViewStateSelector = (): ViewState => {
    return useAppSelector(this.viewStateSelectors)[this.viewName];
  };

  dispatchViewState = (viewState: Partial<ViewState>) => {
    store.dispatch(
      this.dispatchViewStates({
        viewState,
        viewName: this.viewName,
      }),
    );
  };

  dispatchClearView = () => {
    store.dispatch(dispatchClearView(this.viewName));
  };
}
